import React, { useState, useEffect } from 'react';
import { withStorefrontConfig } from '../../hooks/StorefrontSettingsContext';
import { withUserConfig } from '../../hooks/UserConfigContext';
import Loading from '../Loading';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import Checkbox from '@mui/material/Checkbox';
import ImportCSV from './ImportCSV';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';

const ImportCustomers = ({
    usersToImport,
    updateUsersToImport,
    setUsersToImport,
    parsedCustomers,
    setParsedCustomers,
    validFileName,
    setValidFileName,
    currentUser,
    addOnly,
    setAddOnly,
    StorefrontConfig,
    UserConfig
}) => {
    const [selectedUsers, setSelectedUsers] = useState(updateUsersToImport || []);
    const localized = UserConfig.labels;

    useEffect(() => {
        setSelectedUsers(updateUsersToImport || []);
    }, [updateUsersToImport]);

    const handleImportedUsersChange = (e, values) => {
        const ids = values.map(x => x.id);
        setSelectedUsers(ids);
        setUsersToImport(ids);
    };

    if (!StorefrontConfig.storefrontSettingsLoaded) {
        return <Loading type="brand" />;
    }

    return (
        <>
            <Box style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <Typography variant="h3" sx={{ fontWeight: "bold" }}>{localized.ImportCustomers}</Typography>
                <Tooltip sx={{ marginBottom: "10px" }} title={<h3>{localized.CSVImportTooltip}</h3>}>
                    <IconButton>
                        <InfoIcon fontSize="large" />
                    </IconButton>
                </Tooltip>
            </Box>

            <Box style={{ paddingTop: "2rem", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <ImportCSV
                    localized={localized}
                    multiple={false}
                    accept=".csv"
                    currentUser={currentUser}
                    parsedCustomers={parsedCustomers}
                    setValidFileName={setValidFileName}
                    setParsedCustomers={setParsedCustomers}
                />
                <div>{validFileName}</div>
            </Box>

            <Typography variant="h5" sx={{ fontWeight: "bold", paddingTop: "2rem" }}>
                {localized.SelectUsersForImport}
            </Typography>
            <br /><br />

            <Autocomplete
                multiple
                id="tags-standard"
                size="lg"
                disablePortal
                PopperComponent={(props) => (
                    <Popper {...props} placement="bottom-start">
                        {props.children}
                    </Popper>
                )}
                options={usersToImport}
                getOptionLabel={(option) => option.email}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                        <Chip
                            label={option.email}
                            {...getTagProps({ index })}
                            sx={{
                                background: 'white',
                                color: 'black',
                                fontSize: "15px",
                                height: "100%",
                                width: '100%',
                                padding: "10px"
                            }}
                        />
                    ))
                }
                onChange={handleImportedUsersChange}
                defaultValue={selectedUsers}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={localized.SelectUsersForImport}
                    />
                )}
            />

            <Box sx={{ display: 'flex', justifyContent: 'center', width: 'fit-content' }}>
                <Box>
                    <Typography variant="h6" sx={{ marginTop: "5px", fontWeight: "bold" }}>
                        {localized.DeleteExistingCustomers}
                    </Typography>
                </Box>
                <Box>
                    <Checkbox
                        onChange={setAddOnly}
                        checked={addOnly}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                </Box>
            </Box>
        </>
    );
};
export default withStorefrontConfig(withUserConfig(ImportCustomers));
